import CollapseTreeItemIcon from "@mui/icons-material/IndeterminateCheckBoxOutlined";
import ExpandTreeItemIcon from "@mui/icons-material/AddBoxOutlined";
import LockIcon from "@mui/icons-material/Lock";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Unstable_Grid2";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import clsx from "clsx";
import { useSelector } from "react-redux";
import {
  ACCOUNT_FEATURES,
  ACCOUNT_FEATURES_NAMES,
  ACCOUNT_SUBTYPES,
  ACCOUNT_TYPES,
  hasFeature,
  selectAccountRelations,
  selectors as coaSelectors,
} from "../../../redux/coa";

const AccountRowBase = (props) => {
  const account = useSelector((state) =>
    props.root ? null : coaSelectors.selectById(state, props.id),
  );

  const deleteInProgress = !!account?.deleteInProgress;

  const isLocked = hasFeature(
    account?.features,
    ACCOUNT_FEATURES.SYSTEM_LOCKED,
  );
  const inactive = hasFeature(account?.features, ACCOUNT_FEATURES.INACTIVE);
  const blockPosting = hasFeature(
    account?.features,
    ACCOUNT_FEATURES.NO_POSTING,
  );
  const contraAccount = hasFeature(
    account?.features,
    ACCOUNT_FEATURES.CONTRA_ACCOUNT,
  );

  const accountRelations = useSelector(selectAccountRelations);

  const label = props.root ? (
    ACCOUNT_TYPES[props.id]
  ) : (
    <Grid container xs={12} spacing={1}>
      <Grid xs={12} sm={7} md={6}>
        <Grid container alignItems="center">
          <Typography>{`${account?.code} - ${account?.name}`}</Typography>
          {isLocked && (
            <Box
              component={LockIcon}
              sx={{ fontSize: "16px", marginLeft: "4px" }}
            />
          )}
        </Grid>
      </Grid>
      <Grid display={{ xs: "none", sm: "block" }} sm={5} md={3}>
        {ACCOUNT_SUBTYPES[account?.type]?.name}
      </Grid>
      <Grid display={{ xs: "none", md: "block" }} md={3}>
        {[
          ...(blockPosting
            ? [ACCOUNT_FEATURES_NAMES[ACCOUNT_FEATURES.NO_POSTING]]
            : []),
          ...(contraAccount
            ? [ACCOUNT_FEATURES_NAMES[ACCOUNT_FEATURES.CONTRA_ACCOUNT]]
            : []),
        ].join(", ")}
      </Grid>
    </Grid>
  );

  return (
    <TreeItem
      disabled={deleteInProgress}
      nodeId={props.id}
      label={label}
      collapseIcon={<CollapseTreeItemIcon />}
      expandIcon={<ExpandTreeItemIcon />}
      ContentProps={{ className: clsx({ InProgress: deleteInProgress }) }}
      className={clsx(props.className, {
        Inactive: props.root ? false : inactive || deleteInProgress,
        DeleteInProgress: deleteInProgress,
      })}
      onContextMenu={props.onContextMenu(account)}
      onTouchStart={props.onTouchStart(account)}
      onTouchEnd={props.onTouchEnd}
      onTouchMove={props.onTouchMove}
    >
      {accountRelations[props.id]?.map((id) => (
        <AccountRow
          key={id}
          id={id}
          onContextMenu={props.onContextMenu}
          onTouchStart={props.onTouchStart}
          onTouchEnd={props.onTouchEnd}
          onTouchMove={props.onTouchMove}
        />
      ))}
    </TreeItem>
  );
};

const AccountRow = styled(AccountRowBase)(
  ({ theme }) => `
  .MuiTreeItem-content {
    border-radius: 5px;
    padding: 8px 16px;
    position: relative;
  }

  .MuiTreeItem-content.Mui-focused {
    background-color: transparent;
  }

  .MuiTreeItem-content:hover {
    background-color: transparent;
    background-image:
      repeating-linear-gradient(90deg, ${theme.palette.secondary.main}, ${
        theme.palette.secondary.main
      } 1px, transparent 1px, transparent 2px, ${theme.palette.secondary.main} 2px),
      repeating-linear-gradient(90deg, ${theme.palette.secondary.main}, ${
        theme.palette.secondary.main
      } 1px, transparent 1px, transparent 2px, ${theme.palette.secondary.main} 2px);
    background-size: 100% 1px;
    background-position: 0 0, 0 100%;
    background-repeat: no-repeat;
  }

  .MuiTreeItem-content.InProgress {
    background-color: ${theme.palette.background.paper};
  }

  .MuiTreeItem-iconContainer > .MuiSvgIcon-root {
    font-size: 16px;
  }

  .DeleteInProgress .Mui-disabled {
    opacity: 1;
  }
  .DeleteInProgress:hover,
  .DeleteInProgress:hover * {
    background-image: none;
  }

  .Inactive {
    color: ${theme.palette.grey["600"]};
    font-family: milliard-light;
  }
`,
);

export default AccountRow;
